'use strict'

angular.module('rmBroadcast')
    .config(['$stateProvider', function ($stateProvider) {

        let presenterCreateStateCreate = {
            url: '/new-presenter',
            views: {
                'presenter-detail@': {
                    templateUrl: '/partial/app.partials.presenter.detail',
                    controller: 'PresenterFormCtrl',
                    controllerAs: 'presenterCtrl',
                },
            },
            params: {
                fromOtherSource: true
            },
            onEnter: ['$state', 'bladesManager', function ($state, bladesManager) {
                const loadedViews = bladesManager.all()
                const found = loadedViews.some(v => v.viewName === 'presenter-detail')

                if (!found) {
                    bladesManager.insertRight({ viewName: 'presenter-detail', size: 'half' })
                }
            }],
            onExit: ['$state', '$stateParams', 'bladesManager', function ($state, $stateParams, bladesManager) {
                //ugly!
                if ($state.includes('broadcast.create')) {
                    bladesManager.removeRight('presenter-detail')
                } else if ($state.includes('broadcast.update')) {
                    bladesManager.removeRight('presenter-detail')
                }
            }]
        }
        let presenterCreateStateUpdate = angular.copy(presenterCreateStateCreate)

        let programCreateStateCreate = {
            url: '/new-program',
            views: {
                'program-detail@': {
                    templateUrl: '/partial/app.partials.program.detail',
                    controller: 'ProgramFormCtrl',
                    controllerAs: 'programCtrl',
                },
            },
            params: {
                fromOtherSource: true
            },
            onEnter: ['$state', 'bladesManager', function ($state, bladesManager) {
                const loadedViews = bladesManager.all()
                const found = loadedViews.some(v => v.viewName === 'program-detail')

                if (!found) {
                    bladesManager.insertRight({ viewName: 'program-detail', size: 'half' })
                }
            }],
            onExit: ['$state', '$stateParams', 'bladesManager', function ($state, $stateParams, bladesManager) {
                //ugly!
                if ($state.includes('broadcast.create')) {
                    bladesManager.removeRight('program-detail')
                } else if ($state.includes('broadcast.update')) {
                    bladesManager.removeRight('program-detail')
                }
            }]
        }
        let programCreateStateUpdate = angular.copy(programCreateStateCreate)

        let programPresenterCreateStateCreate = angular.copy(presenterCreateStateCreate)
        let programPresenterCreateStateUpdate = angular.copy(programPresenterCreateStateCreate)

        $stateProvider
            .state('broadcast', {
                url: '/broadcast',
                views: {
                    'broadcast-overview': {
                        templateUrl: '/partial/app.partials.broadcast.overview',
                        controller: 'BroadcastOverviewCtrl',
                        controllerAs: 'BroadcastCtrl',
                    },
                    'broadcast-detail': {
                        templateUrl: '/partial/app.panels.empty',
                    },
                },

                onEnter: ['bladesManager', (bladesManager) => {
                    bladesManager.clearAll()
                    bladesManager.insert({ viewName: 'broadcast-overview', size: 'half' })
                    bladesManager.insert({ viewName: 'broadcast-detail', size: 'half' })
                }],
            })
            .state('broadcast.create', {
                url: '/create',
                views: {
                    'broadcast-detail@': {
                        templateUrl: '/partial/app.partials.broadcast.detail',
                        controller: 'BroadcastFormCtrl',
                        controllerAs: 'bcCtrl',
                    },
                },
            })
            .state('broadcast.update', {
                url: '/update/:broadcastId',
                views: {
                    'broadcast-detail@': {
                        templateUrl: '/partial/app.partials.broadcast.detail',
                        controller: 'BroadcastFormCtrl',
                        controllerAs: 'bcCtrl',
                    },
                },
            })
            .state('broadcast.create.presenter', presenterCreateStateCreate)
            .state('broadcast.update.presenter', presenterCreateStateUpdate)
            .state('broadcast.create.program', programCreateStateCreate)
            .state('broadcast.update.program', programCreateStateUpdate)
            .state('broadcast.create.program.presenter', programPresenterCreateStateCreate)
            .state('broadcast.update.program.presenter', programPresenterCreateStateUpdate)
    }])

